module.exports = __webpack_public_path__ + "img/thai.e0953ad8.jpg";